import React from "react";

export default function SQLServer_COUNT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_COUNT</h1>
      <p>This is the SQLServer_COUNT component generated from the SQL JSON.</p>
    </div>
  );
}
